import { DisplayBehavior, ToolTipType, ToolTipWrapper } from "app/core/components/hints"
import { FC } from "react"
import { FiAlertTriangle } from "@superwall/icons/fi/FiAlertTriangle"

export const FormError: FC<{
  normalizedError: string
  hasLabel: boolean
  isDropdown?: boolean
}> = ({ normalizedError, hasLabel, isDropdown }) => {
  const rightPosition = isDropdown ? "right-4" : "right-0"
  return (
    <ToolTipWrapper
      role="alert"
      className={`
          text-[#FF5959]
          appearance-none
          absolute
          mr-3 ${rightPosition}`}
      displayBehavior={DisplayBehavior.Hover}
      toolTip={{ state: ToolTipType.Standard, value: normalizedError }}
      style={{ top: hasLabel ? "40px" : "12px" }}
    >
      {/* <FiAlertTriangle className="text-alert-primary" /> */}
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
        <title>warning-sign</title>
        <g fill="currentColor">
          <path
            d="M23.641,18.485L14.732,1.643C13.931,.134,12.059-.44,10.55,.361c-.546,.29-.992,.736-1.282,1.282L.359,18.485c-.793,1.504-.217,3.367,1.288,4.16,.445,.235,.942,.357,1.445,.355H20.908c1.7,.005,3.083-1.369,3.088-3.07,.002-.504-.12-1-.355-1.445Zm-11.641,1.515c-.828,0-1.5-.672-1.5-1.5s.672-1.5,1.5-1.5,1.5,.672,1.5,1.5-.672,1.5-1.5,1.5Zm.53-5h-1.061c-.264,0-.483-.205-.499-.469l-.438-7c-.018-.288,.211-.531,.499-.531h1.936c.288,0,.517,.243,.499,.531l-.438,7c-.016,.264-.235,.469-.499,.469Z"
            fill="currentColor"
          ></path>
        </g>
      </svg>
    </ToolTipWrapper>
  )
}

export default FormError
